var _path, _path2, _g, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSamoocenca(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 154,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#samoocenca_svg__clip0_632_7383)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "samoocenca_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: -10,
    width: 127,
    height: 134
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.176 103.982l15.638-16.458 6.213-16.064-3.605-18.73 6.876-17.78-3.173-11.617 14.552-6.4-2.37-12.092 25.584-5.935L108.116-10 60.503 3.328 28.411 28.405l3.419 33.671 11.522 25.448 24.78 32.225 15.519 4.067 11.525-19.834z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#samoocenca_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "samoocenca_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 3,
    width: 106,
    height: 106
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.829 108.931c29.161 0 52.801-23.64 52.801-52.801 0-29.162-23.64-52.801-52.801-52.801-29.16 0-52.8 23.64-52.8 52.8 0 29.162 23.64 52.802 52.8 52.802z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#samoocenca_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.829 108.931c29.161 0 52.801-23.64 52.801-52.801 0-29.162-23.64-52.801-52.801-52.801-29.16 0-52.8 23.64-52.8 52.8 0 29.162 23.64 52.802 52.8 52.802z",
    fill: "#F0F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.898 30.212s-9.03-3.16-15.602 5.97C90.275 48.716 89.6 78.258 89.6 78.258l4.39.173.907-4.954 1.245 5.562 11.167.439 13.052.513 9.289-.276 1.645-5.646.154 5.597 9.672-.255s2.655-35.95-10.686-46.197c-7.04-5.408-15.54-3.003-15.54-3.003l.004.002z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.336 65.733s4.869 13.487-4.317 19.917c3.491 12.312 7.074 19.203 7.074 19.203l6.13 18.873 6.734-18.873 6.155-16.445s-7.259-5.887-3.123-22.673c-6.615-4.475-18.651 0-18.651 0l-.002-.002z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.96 55.358c-.672-12.654 4.575-23.206 16.541-22.895 13.182.342 14.881 10.596 14.489 22.895-.389 12.248-6.353 23.102-14.707 22.912-7.225-.165-15.598-9.188-16.326-22.912h.002z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.664 49.648s-3.143 7.877 1.356 12.54l-2.755 3.212M113.084 48.23s-5.299-1.896-9.618 3.183M119.218 48.283s4.952-2.1 8.561 3.328",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.427 54.703c.056.856.667 1.47 1.378 1.423.708-.045 1.245-.734 1.191-1.59-.055-.856-.731-1.455-1.442-1.408-.708.045-1.181.72-1.127 1.575z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.736 55.257s-3.679-4.829-7.885.105",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.732 54.489c-.034.858-.678 1.485-1.388 1.457-.71-.028-1.217-.702-1.183-1.56.034-.858.633-1.457 1.343-1.429.711.028 1.26.674 1.228 1.532z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.055 54.983s3.335-4.454 7.885-.092",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.736 38.972s-.463 10.675 8.424 12.64c-4.298-4.87-3.29-9.897-3.29-9.897s5.412 7.278 15.433 8.711c-.717-7.055-4.09-14.389-4.09-14.389l-4.557-2.589-8.155-.988-7.026-.445-6.009 4.165-3.564 6.88-1.675 10.378s12.142-8.23 14.509-14.468v.002z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.982 44.039s-11.589 18.07-6.208 29.935M134.721 44.039s11.588 18.07 6.208 29.935",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.979 69.563s2.263-3.663 4.165-2c2.03-1.543 4.401 2 4.401 2s-3.609-1.712-8.568 0h.002z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.467 83.697l12.111 15.282 10.591-15.282 6.296 2.347a34.695 34.695 0 0121.7 24.789l5.885 25.809H73.612l2.826-22.962a34.69 34.69 0 0122.57-28.361l4.461-1.622h-.002z",
    fill: "#008AE9"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "samoocenca_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: -1,
    width: 96,
    height: 122
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.587 104.737l15.638-16.458 6.213-16.064-3.605-18.73 6.876-17.78-3.172-11.617 14.551-6.4-2.37-12.092L157.3-.34l9.704 34.692-.847 2.503-5.524 4.12 5.085-.701 4.76 2.105 22.384 20.847-14.205 30.25-17.996-3.846-.392-9.588-2.92 5.825-.575 8.153-5.736 26.485-32.023-10.84-1.333-1.602h-3.956l-.501-4.144-7.147 4.144-5.284 12.442-3.207-15.769z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#samoocenca_svg__c)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.238 109.685c29.161 0 52.801-23.64 52.801-52.8 0-29.162-23.64-52.802-52.801-52.802-29.162 0-52.802 23.64-52.802 52.801s23.64 52.801 52.802 52.801z",
    fill: "#008AE9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "samoocenca_svg__d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 4,
    width: 107,
    height: 106
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.237 109.685c29.161 0 52.801-23.64 52.801-52.8 0-29.162-23.64-52.802-52.801-52.802-29.162 0-52.801 23.64-52.801 52.801s23.64 52.801 52.801 52.801z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#samoocenca_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.862-7.993H40.49v119.736h152.372V-7.993z",
    fill: "#F0F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.309 30.967s-9.031-3.16-15.603 5.97c-9.021 12.533-9.697 42.075-9.697 42.075l4.39.173.907-4.954 1.245 5.562 11.167.438 13.052.514 9.289-.276 1.645-5.646.155 5.597 9.671-.255s2.655-35.95-10.686-46.197c-7.04-5.408-15.54-3.004-15.54-3.004l.005.003z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.743 66.488s4.869 13.487-4.317 19.917c3.491 12.312 7.075 19.203 7.075 19.203l6.129 18.873 6.734-18.873 6.155-16.445s-7.258-5.887-3.123-22.673c-6.615-4.475-18.651 0-18.651 0l-.002-.002z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.367 56.112c-.672-12.654 4.576-23.205 16.541-22.895 13.183.343 14.881 10.596 14.49 22.895-.39 12.248-6.354 23.103-14.708 22.913-7.225-.165-15.598-9.189-16.326-22.913h.003z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.07 50.403s-3.143 7.877 1.356 12.54l-2.755 3.211M115.492 48.984s-5.299-1.895-9.618 3.183M121.624 49.038s4.953-2.1 8.562 3.328",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.836 55.46c.056.856.668 1.47 1.378 1.423.708-.045 1.245-.734 1.191-1.59-.055-.856-.731-1.455-1.441-1.408-.709.045-1.181.72-1.128 1.575z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.143 56.014s-3.679-4.828-7.885.105",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.14 55.244c-.035.858-.679 1.485-1.389 1.457-.71-.028-1.217-.702-1.183-1.56.034-.858.633-1.457 1.344-1.429.71.028 1.26.674 1.228 1.532z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.464 55.738s3.335-4.454 7.885-.092",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.143 39.727s-.463 10.675 8.424 12.64c-4.298-4.87-3.519-10.186-3.519-10.186s5.642 7.567 15.664 9c-.716-7.055-4.09-14.39-4.09-14.39l-4.557-2.588-8.155-.988-7.026-.445-6.009 4.165-3.564 6.88-1.675 10.378s12.143-8.23 14.509-14.468l-.002.002z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.39 44.793S87.8 62.864 93.18 74.73M137.127 44.793s11.589 18.071 6.208 29.936",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.388 70.317s2.263-3.662 4.165-2c2.03-1.542 4.401 2 4.401 2s-3.609-1.71-8.568 0h.002z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.876 84.452l12.111 15.281 10.592-15.28 6.296 2.346a34.692 34.692 0 0121.699 24.789l5.885 25.808H76.021l2.826-22.961a34.69 34.69 0 0122.571-28.361l4.46-1.622h-.002z",
    fill: "#008AE9"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.537 24.088l14.552-6.4 7.674 1.306 2.834-4.42 3.4-1.698",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.423 17.753l-5.821-.887-6.839 2.128M171.182 47.989l-5.197 5.701 1.677 3.218-12.771 9.128 5.226 10.228.546 13.367",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156.776 94.021l.576-8.153 2.894-6.445M113.227 88.28l-1.541 8.45 1.541 7.19-7.148 4.144M90.89 10.15c7.862-4.475 16.997-7.023 26.758-7.023M67.562 74.936a52.178 52.178 0 01-3.43-18.653c0-11.959 3.882-22.916 10.46-31.737M75.048 88.279c5.128 6.653 12.085 12.185 19.883 15.884l15.882-16.64 6.213-16.064-3.605-18.73 4.444-11.015M166.705 80.043s5.117-9.563 5.321-21.544M157.93 20.815s5.755 5.229 9.075 13.538M129.305 4.84l2.371 12.092-14.552 6.401 3.173 11.617",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.946 76.502s5.498 15.226-4.876 22.487c3.941 13.899 7.986 21.677 7.986 21.677l6.92 21.308 7.602-21.308 6.951-18.567s-8.194-6.647-3.526-25.6c-7.468-5.052-21.055 0-21.055 0l-.002.003z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.748 64.787C28.99 50.501 34.912 38.59 48.424 38.94c14.884.387 16.8 11.963 16.358 25.847-.441 13.827-7.174 26.083-16.604 25.867-8.157-.186-17.609-10.376-18.43-25.867z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.707 96.785s5.37-1.927 13.093-1.927c7.272 0 12.539 1.927 12.539 1.927l7.107 2.65a39.163 39.163 0 0124.497 27.988l6.645 29.137H0l3.192-25.922a39.163 39.163 0 0125.482-32.02l5.033-1.83v-.003z",
    fill: "#008AE9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.614 36.398S36.42 32.832 29 43.139c-10.186 14.15-10.947 47.5-10.947 47.5l4.957.194 1.024-5.594 1.406 6.279 12.61.496 14.735.58 10.49-.31 1.858-6.373.176 6.32 10.919-.287s3-40.588-12.066-52.155c-7.95-6.106-17.545-3.391-17.545-3.391h-.002z",
    fill: "#333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.387 52.007s-13.082 20.402-7.009 33.797M68.991 52.007S82.073 72.409 76 85.804M22.075 135.668v20.89M77.61 135.668v20.89",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "samoocenca_svg__clip0_632_7383"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h167v154H0z"
  })))));
}
export default __webpack_public_path__ + "static/samoocenca.ca4605d3.svg";
export { SvgSamoocenca as ReactComponent };